import "./Header.css";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../Navbar/Navbar.js";


const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="hero" id="home">
      <Navbar />

      {/* Hero Content */}
      <div className="hero-content">
        <h1 className="web-title">Elevate Your Space</h1>
        <h1>Designing Spaces That Tell Your Story</h1>
        <p>Elegant. Functional. Timeless interiors crafted just for you.</p>
        <button onClick={() => navigate("/projects")}>Explore Designs</button>
      </div>
    </header>
  );
}

export { Header };